import React, { useState } from "react";
import { useParams } from "react-router-dom";
import logo from '../../assets/logo.png'
import "../../App.css"
import axios from "axios";

const Verification = () => {

    const { id } = useParams()
    const [verificationMessage, setVerificationMessage] = useState(false);
    const [message, setMessage] = useState('Click the button below to verify your account:')

    const verifyAccount = async () => {
        const apiEndpoint = "https://api.ipinplus.com/user/verification/";
        try {
            const response = await axios.put(apiEndpoint, {
                tokens: id
            })
            const { data } = response
            if (data?.success) {
                alert(data?.message);
                setMessage("Congratulations! Your account got verified, you can now login into Pinplus using your account.")
                setVerificationMessage(true)
            } else {
                alert(data?.message);
            }
        } catch (error) {
            console.error("Error:", error);
            alert(error.message);
        }
    };

    return (
        <div className="body">
            <div className="container">
                <div className="logo">
                    <img src={logo} alt="Logo" width='100%' />
                </div>
                <p>{message}</p>
                {!verificationMessage && <button className="verifyBtn" onClick={verifyAccount}>
                    Verify your account
                </button>
                }
            </div>
        </div>
    );
};


export default Verification;
